import React, {useEffect, useState} from "react";
import Space from "../../commons/Space";
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import 'bs5-lightbox';
import SpaceL from "../../commons/SpaceL";
import "../../styles/Master.css";
import TitoloColore from "../../commons/TitoloColore";
import foto1 from "../../images/Nuoto/Ago/4 x 100 Mista F Junior - 3 classificati.png"
import foto2 from "../../images/Nuoto/Ago/I medagliati visione d'insieme .jpeg"
import foto3 from "../../images/Nuoto/Ago/Staffetta Mista 4x50 bronzo copia.jpeg"
import foto4 from "../../images/Nuoto/Ago/4x50 SL Juniores - bronzo Sebastian, Corrado, Riccardo, Nicolas.png"
import foto5 from "../../images/Nuoto/Ago/Le medaglie.jpeg"
import foto6 from "../../images/Nuoto/Ago/Sebastian Argento 200 MX Junior.jpeg"
import foto7 from "../../images/Nuoto/Ago/Vania Bronzo 100DR Esordienti A .jpeg"
import foto8 from "../../images/Nuoto/Ago/Oro Staffetta 50 SL Juniores.jpeg"
import ReactPlayer from "react-player";


function GarePreAgo() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (

        <div>
            <ScrollToTopOnMount />
            <TitoloColore title={"Agonismo"} backgroundColor={"#003F83"} />
            <FrecciaIndietro indirizzo={"/corsinuoto"} />
            <div style={{padding: "1em"}}>
                <h1 className="text-center" style={{fontFamily: "Hammersmith One", padding: "1em"}}>Risultati Gare</h1>

                <div className="text-center">
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/01%20-%2014DIC25%20TORTONA.pdf" download> Classifica società</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/01%20-%2014DIC25%20TORTONA.pdf" download> 14 dicembre 2025 - Tortona</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/03%20-%2025FEB24%20TORTONA.pdf" download> 25 febbraio 2024 - Tortona</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/04%20-%2024MAR24%20TORTONA.pdf" download> 24 marzo 2024 - Tortona</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/05%20-%2021APR24%20MONZA.pdf" download> 21 aprile 2024 - Monza</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/06%20-%2026MAG24%20MONZA.pdf" download> 26 maggio 2024 - Monza</a>

                </div>
                <div className="d-flex flex-row container-news" style={{ overflowX: "auto", marginTop: "1em" }}>
                    <img src={foto8} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto1} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto2} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto3} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto4} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto5} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto6} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto7} className="img-fluid img-thumbnail news-img" alt="..." />
                </div>
                <SpaceL />
                {windowWidth > 900 ? (
                        <ReactPlayer config={{ file: {
                                attributes: {
                                    controlsList: 'nodownload'
                                }}
                        }}
                                     style={{margin: "auto"}}
                                     url='https://www.ilcignosport.it/Dimostrazione_agonisti.mp4'
                                     controls={true}

                        />
                    ):
                    windowWidth > 650 && windowWidth < 900 ? (
                            <ReactPlayer config={{ file: {
                                    attributes: {
                                        controlsList: 'nodownload'
                                    }}}} style={{margin: "auto"}} url='https://www.ilcignosport.it/Dimostrazione_agonisti.mp4' controls={true} width={"100%"} height={"auto"}/>
                        )
                        : (
                            <ReactPlayer config={{ file: {
                                    attributes: {
                                        controlsList: 'nodownload'
                                    }}
                            }}
                                         style={{margin: "auto"}}
                                         url='https://www.ilcignosport.it/Dimostrazione_agonisti.mp4'
                                         controls={true}
                                         width={"100%"}
                                         height={"auto"}
                            />
                        )}
                <Space />

                <Space />
            </div>
        </div>
    )
}

export default GarePreAgo;
